import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import orthodoxLogo from '../../assets/orthodox-church-logo.png';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <div>
            <div className="flex items-center space-x-3 mb-3">
              <div className="w-12 h-14 flex items-center justify-center">
                <img src={orthodoxLogo} alt="Orthodox Church Logo" className="w-full h-full object-contain" />
              </div>
              <div>
                <h3 className="text-lg font-bold">St. Mary’s Indian Orthodox Church</h3>
                <p className="text-sm text-gray-400">San Antonio, Texas</p>
              </div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              Preserving the ancient Christian traditions of the Malankara Orthodox Church, 
              tracing our heritage back to St. Thomas the Apostle.
            </p>
          </div>

          <div className="lg:ml-[10rem]">
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-gray-400 hover:text-red-600 transition-colors">About Us</Link></li>
              <li><Link to="/services" className="text-gray-400 hover:text-red-600 transition-colors">Services</Link></li>
              <li><Link to="/eventsandnews" className="text-gray-400 hover:text-red-600 transition-colors">Events & News</Link></li>
              <li><Link to="/organizations" className="text-gray-400 hover:text-red-600 transition-colors">Organizations</Link></li>
              <li><Link to="/gallery" className="text-gray-400 hover:text-red-600 transition-colors">Gallery</Link></li>
              <li><Link to="/donate" className="text-gray-400 hover:text-red-600 transition-colors">Donate</Link></li>
            </ul>
          </div>

          <div className='lg:ml-[5rem]'>
            <h4 className="text-lg font-semibold mb-4">Contact Info</h4>
            <ul className="space-y-3">
              <li className="flex items-start">
                <MapPin className="w-5 h-5 text-red-600 mr-2 mt-0.5" />
                <a href="https://maps.app.goo.gl/fyuD2QotERpAXvao9" className="text-gray-400 text-sm hover:text-red-600">
                  4990 View Dr, San Antonio, TX 78228
                </a>
              </li>
              <li className="flex items-center">
                <Phone className="w-5 h-5 text-red-600 mr-2" />
                <a href="tel:+1 210-573-8856" className="text-gray-400 text-sm hover:text-red-600">
                  +1 210-573-8856
                </a>
              </li>
              <li className="flex items-center">
                <Mail className="w-5 h-5 text-red-600 mr-2" />
                <a href="mailto:tpooovathoor@gmail.com" className="text-gray-400 text-sm hover:text-red-600">
                  tpooovathoor@gmail.com
                </a>
              </li>
            </ul>

            <div style={{marginTop: '2.5rem'}}>
              <h5 className="text-sm font-semibold mb-3">Follow Us</h5>
              <div className="flex space-x-3">
                <a href="https://www.facebook.com/sanantoniostmarys.org/" className="text-gray-400 hover:text-red-600 transition-colors" target="_blank" rel="noopener noreferrer">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                  </svg>
                </a>
                
                <a href="https://www.youtube.com/@StMarysIndianOrthodoxChurchSAT/featured" className="text-gray-400 hover:text-red-600 transition-colors" target="_blank" rel="noopener noreferrer">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                  </svg>
                </a>
                
                {/* Commenting Twitter and Instagram icons as there are no pages available at the moment
                <a href="https://x.com/stmarysorthodox" className="text-gray-400 hover:text-red-600 transition-colors" target="_blank" rel="noopener noreferrer">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24H4.298Z"/>
                  </svg>
                </a>
                <a href="https://www.instagram.com/stmarysorthodox" className="text-gray-400 hover:text-red-600 transition-colors" target="_blank" rel="noopener noreferrer">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                  </svg>
                </a> */
                }
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            © 2025 St. Mary's Malankara (Indian) Orthodox Church. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;